import { ToastVariant } from "./types";

export const TOAST_DURATION = 8000;

export const VARIANT_CLASS: Record<ToastVariant, string> = {
  success: "!bg-green-600 !text-white",
  error: "!bg-red-500 !text-white",
  warning: "!bg-yellow-500 !text-white",
};
